export const locale = {
  lang: 'en',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO':'Loading leaders',
        'TEX_FILT_INFO':'Filtering leaders',
        'TEX_TITL_TAB1':'Selecting leaders',
        'TEX_TITL_TAB2':'Preview selected leaders',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1':'*Select leaders to apply',
        'TEX_INDIC_BUSQ':'Enter name, email or area',
        'TEX_BTN_FILT':'Filter',
        'TH_1':'Leader name',
        'TH_2':'Mail',
        'TH_3':'Area',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7':'CGO user status',
        'TH_EMA_LOCA':'Locality',
        'TH_EMA_SEND':'Mails sent',
        'TH_PUEST_LEAD':'Job Title',
        'STATUS_LOGIN_CGO':{
        'false':'Inactive',
        'true':'Active',
        'undefined':'Inactive',
        },
        'MODAL_ACTU_BAN_UNI':'Adding selected leader',
        'MODAL_ACTU_BAN_MUL':'Adding selected leaders',
        'WARNI_NO_SELEC':'Cannot complete the step yet, as no leader has been selected',
        'COMFI_COMP_PAS':'Are you sure you have completed the leader selection step?',
        'BTN_CONFI_OK':'OK',
        'BTN_CONFI_YES':'Yes',
        'BTN_CONFI_NO':'No',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span> To send invitation emails, enter the code in red in the text box ',
        'MSN_INGR_COD2':'</span>',
        'MODAL_CONFI_SEND_MAIL':'Are you sure to send the emails?',
        'MODAL_CONFI_ACTIV_USER_CGO':'Are you sure to activate the user?',
        'MODAL_CONFI_DESACTIV_USER_CGO':'Are you sure to deactivate the user?',
        'MSN_INGR_COD_ACTI_USER':'<span> To activate/deactivate the user, enter the code in red into the text box  ',
        'MODAL_ERR_COD':'The placed text does not match',
        'WARNI_NO_SELEC_LEA':'To be able to send mails, select at least one leader',
        'BTN_SEND_MAIL':'Send mails',
        'BTN_CONFI_CONFIRMAR':'Confirm',
        'BTN_CONFI_CANCELAR':'Cancel',
        'MOD_INFO_SEN_EMA':'Sending mails...',
        'SUCCE_SEN_EMA':'They have been sent successfully',
        'NO_LEAD_PRODUCT_ASO':'The associated certificate for this product does not contain lead users.',
        'MOD_ACTI_USE_CGO':'Updating user status',
        'SUCCE_UPDA_STA_USE':'Successfully updated',
      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'Are you sure you have completed the mail editor step? ',
      'FECHAS':{
        'TITULO':'Select dates',
        'BTN_TEXT':'Select dates',
        'INSTRUC_TEXT':'Select and register the different dates available to configure',
      },
      'CORREOS':{
        'TITULO':'Communication messages',
        'BTN_TEXT':'View communication messages',
        'INSTRUC_TEXT':'Review the communication messages to be sent',
       'TIPOS_CORREO':{
         'TIPO1_INVITA':{
           'TITULO': 'Invitation message',
            'DESCRIP': 'This is the message sent to the leaders on the day of the call launch',
         },
         'TIPO2_RECOR_NO_INI':{
           'TITULO':'Message to leaders who have not started',
            'DESCRIP':'This is the reminder message sent to leaders who have not yet initiated',
         },
         'TIPO3_RECOR_NO_FINA':{
           'TITULO':'Message to the leaders who have not yet finished.',
            'DESCRIP':'This is the reminder message sent to the leaders who have already started their survey but have not yet finished',
         },
       }
      },
      'MODAL_ACCIO':{
    'TIPO_ACCIO_FECH':{
       'TITU_TEXT1':'Select each of the available dates to configure',
      }
      },
      'ETIQ':{
        'tag_name':'The name of the leader',
          'tag_codeCoupon':'The coupon code',
          'tag_productoId':'The product id',
          'tag_nameCourse':'The name of the course',
      }
    },
    'TIP_EMAI': {
      'lanzamiento': 'Invitation launch date',
      'aviso1': 'Pre-release (First prompt before survey launch)',
      'aviso2': 'Pre-launch (Second prompt before survey launch)',
      'cierre': 'Closing date',
      'recordatorio1': 'Date of sending the reminder to those who have not yet started',
      'recordatorio2': 'Date of sending the reminder to those who have not finished',
    },
    'SECCION_CONFIRM':{
      'BTN_CONFIRM_ENVIO':'Confirm mailing',
      'BTN_ENVIO_CONFIRM':'The mailing has been confirmed',
      'MODAL_COMPL_CONF':'Are you sure you have completed the mailing confirmation step?',
      'MODAL_WARNIN_CONF':'To complete the step you must confirm the sending of the mails.',
    },
    'SECCI_AVANCE':{
      'CARDS':{
        'PASO_1':{
          'TITULO':'Advancement',
          'DESCRIP':'Leaders advancement ',
          'BTN_1':'Go to count portal',
          'BTN_2':'',
        },
        'PASO_2':{
          'TITULO':'Reminder',
          'DESCRIP':'Reminder to leaders who have not yet started or finished the process',
          'BTN_1':'Reminder',
          'BTN_2':'',
        }
      }
    },
    },
    'ACTION_GO':{
      'COLUMNAS':{
          'NameUser':'Name',
          'email':'Mail',
          'Area':'Area',
          'JobTitle':'Post',
          'Localidad':'Location',
          'NumberOfEmails':'Mail sent',
          'Age':'Year',
          'Gneration':'Gender',
          'IdUser':'User Id',
          'SurveyID':'Survey Id',
          'keyUserlogin':'Password',
          'Pass_cgo':'Password',
      }
    }
  }
};
